import "../type-Dku6Xzl6.js";
import { b as i } from "../statistics-IyDYgeE6.js";
const s = ["row-gap", "column-gap"], o = ["padding-block", "padding-inline"], u = [
  ...s,
  ...o
];
function x(a, n) {
  return n === "padding-block" || n === "row-gap" ? `calc(${a} + (1rem / var(--go-ui-optical-correction-factor) - 1rem))` : a;
}
function e(a = "md", n = 0) {
  const g = [
    "0",
    "var(--go-ui-spacing-5xs)",
    "var(--go-ui-spacing-4xs)",
    "var(--go-ui-spacing-3xs)",
    "var(--go-ui-spacing-2xs)",
    "var(--go-ui-spacing-xs)",
    "var(--go-ui-spacing-sm)",
    "var(--go-ui-spacing-md)",
    "var(--go-ui-spacing-lg)",
    "var(--go-ui-spacing-xl)",
    "var(--go-ui-spacing-2xl)",
    "var(--go-ui-spacing-3xl)",
    "var(--go-ui-spacing-4xl)",
    "var(--go-ui-spacing-5xl)"
  ], c = i(
    {
      none: 0,
      "5xs": 1,
      "4xs": 2,
      "3xs": 3,
      "2xs": 4,
      xs: 5,
      sm: 6,
      md: 7,
      lg: 8,
      xl: 9,
      "2xl": 10,
      "3xl": 11,
      "4xl": 12,
      "5xl": 13
    }[a] + n,
    0,
    g.length - 1
  );
  return g[i(
    c,
    0,
    g.length - 1
  )];
}
export {
  u as fullSpacings,
  s as gapSpacings,
  x as getOpticallyCorrectedSpacingValue,
  e as getSpacingValue,
  o as paddingSpacings
};
